import React, { useState } from 'react'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import { useModel } from 'umi'
import { Modal, Checkbox, Tooltip, Button, message as $message } from 'antd'
import { Input } from '@/ui'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CustomIcon from '@/components/CustomIcon'
import styles from './index.less'

const DragHandle = SortableHandle(() => {
    return (
        <div className={styles.drag}>
            <Tooltip overlay={null} title="拖拽排序">
                <CustomIcon className={styles.dragIcon} type="icon-a-Group1000008508" />
            </Tooltip>
        </div>
    )
})

const SortableItem = SortableElement(({ label, checkable, deletable, checked, onCheckChange, onDelete }) => {
    const handleCheckChange = () => {
        onCheckChange(!checked)
    }

    return (
        <div className={styles.item}>
            {checkable ? (
                <div onClick={handleCheckChange} className={styles.checkedLabel}>
                    <Tooltip overlay={null} title="系统默认的问题类型可以设置显示/隐藏">
                        <Checkbox style={{ marginRight: 6 }} checked={checked} />
                    </Tooltip>
                    <Tooltip overlay={null} title={label} placement="topLeft">
                        <div className={styles.label}>{label}</div>
                    </Tooltip>
                </div>
            ) : (
                <div className={styles.uncheckedLabel}>
                    <Tooltip overlay={null} title={label} placement="topLeft">
                        <div className={styles.label}>{label}</div>
                    </Tooltip>
                </div>
            )}
            {deletable && (
                <Tooltip overlay={null} title="若不需要该自定义类型，可以删除">
                    <div className={styles.delete} onClick={onDelete}>
                        <CustomIcon className={styles.deleteIcon} type="icon-shanchu1" />
                    </div>
                </Tooltip>
            )}
            <DragHandle />
        </div>
    )
})

const SortableList = SortableContainer(() => {
    const {
        tempList: list,
        tempCheckedValue: checkedValue,
        checkAfterSalesQuestionType,
        deleteAfterSalesQuestionType
    } = useModel('useAfterSalesQuestionType')

    return (
        <div className={styles.list} id="QuestionTypeList">
            {list.map((item, index) => (
                <SortableItem
                    key={item.question}
                    index={index}
                    checkable={item.systemQuestion}
                    deletable={!item.systemQuestion}
                    checked={checkedValue[item.question]}
                    label={item.question}
                    onCheckChange={checked => checkAfterSalesQuestionType(item.question, checked)}
                    onDelete={() => deleteAfterSalesQuestionType(item.question)}
                />
            ))}
        </div>
    )
})

const Content = () => {
    const [input, setInput] = useState('')
    const { addAfterSalesQuestionType, sortAfterSalesQuestionType } = useModel('useAfterSalesQuestionType')

    const handleSortEnd = ({ oldIndex, newIndex }) => {
        sortAfterSalesQuestionType(oldIndex, newIndex)
    }

    const haddleAdd = () => {
        if (addAfterSalesQuestionType(input)) {
            setInput('')
            setTimeout(() => {
                document.getElementById('QuestionTypeList')?.scrollTo({
                    top: 99999,
                    behavior: 'auto'
                })
            }, 64)
        }
    }

    return (
        <div>
            <div className={styles.row}>
                <div className={styles.rowLabel}>新增问题类型</div>
                <Input.Group compact>
                    <Input
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        style={{ width: 'calc(100% - 64px)' }}
                        placeholder="请输入"
                        maxLength={100}
                        allowClear
                        onPressEnter={haddleAdd}
                    />
                    <Button onClick={haddleAdd} className={styles.rowBtn} type="primary" icon={<CheckOutlined />} />
                </Input.Group>
            </div>
            <SortableList helperClass={styles.sortHelper} lockAxis="y" useDragHandle onSortEnd={handleSortEnd} />
        </div>
    )
}

const AddQuestionTypeModal = ({ visible, onCancel }) => {
    const { updateList, updateLoading } = useModel('useAfterSalesQuestionType')

    const handleOk = async () => {
        await updateList()
        onCancel()
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            confirmLoading={updateLoading}
            title="设置问题类型"
            onOk={handleOk}
        >
            <Content />
        </Modal>
    )
}

export default AddQuestionTypeModal
